<template>
  <div
    v-show="open"
    id="dashboard-filters"
  >
    <b-card class="mb-4">
      <b-row>
        <b-col
          v-for="(filter, key) in filters"
          v-show="!filter.readonly"
          :key="key"
          lg="6"
          :data-filter="key"
        >
          <filter-component
            v-model="filterValues[key]"
            :filter="filter"
          ></filter-component>
        </b-col>
      </b-row>

      <hr>
      <div class="d-flex">
        <b-button
          variant="dark"
          size="sm"
          @click="applyFilters"
        >
          <i class="fa fa-sliders mr-1"></i>
          Apply Filters
        </b-button>
        <b-button
          variant="link"
          class="ml-2 text-body"
          size="sm"
          @click="cancelFilters"
        >
          Cancel
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import FilterComponent from './filters/FilterComponent'

export default {
  name: 'Filters',
  components: {
    FilterComponent
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },

    filters: {
      type: Object,
      default () {
        return {}
      }
    },

    initialValues: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {
      filterValues: {}
    }
  },

  watch: {
    initialValues (values) {
      this.initFilters()
    }
  },

  mounted () {
    this.initFilters()
  },

  methods: {
    initFilters () {
      this.filterValues = Object.assign({}, this.initialValues)
    },

    applyFilters () {
      this.$emit('apply', this.filterValues)
      this.$emit('toggle')
    },

    cancelFilters () {
      this.initFilters()
      this.$emit('toggle')
    }
  }
}
</script>
